
export const logoImage = require('./kaiteki-logo-azul.jpg');

export const appStyles = {
	container: {
	  display: 'flex',
	  flexDirection: 'column' as const,
	  alignItems: 'center',
	  minHeight: '100vh',
	//   backgroundColor: '#5E7390',
	//   backgroundImage: 'linear-gradient(135deg, #3A8DFF 0%, #F5F5F5 100%)',
	},
	logoContainer: {
	  padding: '1rem 5px',
	  display: 'flex',
	  justifyContent: 'space-evenly',
	  alignItems: 'center',
	  width: '100%',
	//   maxWidth: '400px',
	},
	logo: {
	  maxWidth: '200px',
	  height: 'auto',
	  objectFit: 'contain' as const,
	},
	formContainer: {
	  background: 'rgba(255, 255, 255, 0.95)',
	  padding: '2rem',
	  borderRadius: '16px',
	  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
	  border: '1px solid #5E7390',
	  width: '70%',
	  maxWidth: '400px',
	},
	title: {
	  textAlign: 'center' as const,
	  color: '#2d3748',
	  fontSize: '2rem',
	  fontWeight: '700',
	  marginBottom: '2rem',
	  marginRight: '2rem',
	},
	formWrap: {
	  width: '100%',
	  maxWidth: '400px',
	  margin: '0 auto',
	},
	input: {
	  width: '100%',
	  boxSizing: 'border-box' as const,
	  padding: '0.75rem',
	  marginBottom: '1rem',
	  border: '1px solid #e2e8f0',
	  borderRadius: '8px',
	  fontSize: '1rem',
	  transition: 'border-color 0.3s ease',
	  ':focus': {
		outline: 'none',
		borderColor: '#667eea',
		boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.2)',
	  },
	},
	textarea: {
	  width: '90%',
	  padding: '0.75rem',
	  marginBottom: '1rem',
	  border: '1px solid #e2e8f0',
	  borderRadius: '8px',
	  fontSize: '1rem',
	  fontFamily: 'inherit',
	  resize: 'vertical' as const,
	  minHeight: '100px',
	  transition: 'border-color 0.3s ease',
	  ':focus': {
		outline: 'none',
		borderColor: '#667eea',
		boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.2)',
	  },
	},
	button: {
	  width: '100%',
	  padding: '0.75rem',
	  background: '#5E7390',
	  color: 'white',
	  border: '1px solid #5E7390',
	  borderRadius: '8px',
	  fontSize: '1rem',
	  fontWeight: '600',
	  cursor: 'pointer',
	  transition: 'background 0.3s ease',
	  ':hover': {
		background: '#764ba2',
		borderColor: '#764ba2',
	  },
	  ':disabled': {
		background: '#cbd5e0',
		borderColor: '#cbd5e0',
		cursor: 'not-allowed',
		color: 'red',
	  },
	},
	error: {
	  color: '#e53e3e',
	  fontSize: '0.875rem',
	  marginTop: '0.5rem',
	  textAlign: 'center' as const,
	},
	loader: {
	  border: '3px solid #f3f3f3',
	  borderTop: '3px solid #667eea',
	  borderRadius: '50%',
	  width: '20px',
	  height: '20px',
	  animation: 'spin 1s linear infinite',
	},
};
   
  